import { MainContentsProps } from '@raisin/components-lib';
import { ContentProps } from '../types';
import { FAQMarkupQuery } from '../components/FAQMarkupScript';

export const getFAQMarkupQueries = (content: ContentProps) => {
  const faqMarkupQueries: FAQMarkupQuery[] = [];

  if (content.componentName === 'content_columns') {
    const contentProps = content.componentData.content_columns as MainContentsProps[];
    contentProps.forEach((column) => {
      const contentOnly = column.content.filter((item) =>
        Object.prototype.hasOwnProperty.call(item, 'content'),
      );

      if (column.activate_faq_markup && column.headline_text && contentOnly.length) {
        const { headline_text: question } = column;
        const answer = contentOnly.map((item) => item?.content?.text).join(' ');
        faqMarkupQueries.push({
          question,
          answer,
        });
      }
    });
  }

  return faqMarkupQueries;
};
